export function submit(values, dispatch, props) {
    const {headers, handleHide, onHeadersToDisplayChange} = props;
    const newHeaders = headers.map((header) => ({
        ...header,
        show: values[header.field]
    })).filter((header) => header.show);
    onHeadersToDisplayChange(newHeaders);
    handleHide();
}
